import { field, date, relation, text } from '@nozbe/watermelondb/decorators';
import { INVENTORY_SCHEMA } from '../schema';
import { Model } from '@nozbe/watermelondb';

export default class Stock extends Model {
    static table = INVENTORY_SCHEMA;

    static associations = {
        stock: { type: 'belongs_to', key: 'stock_id' },
        orders: { type: 'belongs_to', key: 'order_id' },
    }

    @text('refrence_id') refrence_id;
    @text('table_name') table_name;
    @text('tran_type') tran_type;
    @text('name') name;
    @text('type') type;

    @field('is_secondary_unit') is_secondary_unit;
    @field('unit_conversion') unit_conversion;
    @field('quantity') quantity;
    @field('price') price;

    @date('transacted_at') transacted_at;

    @relation('orders', 'order_id') orders;
    @relation('stock', 'stock_id') stock;
}